import React, { useEffect, useContext } from "react";
import gql from "graphql-tag";
import { get } from "lodash";

import "./CurrentUser.css";
import { Icon } from "../../Icon/Icon";
import { useQuery } from "@apollo/client";
import { useLocation, useHistory } from "react-router-dom";
import { CurrentLanguageContext } from "../../../Context/CurrentLanguageContext/CurrentLanguageContext";

export const CurrentUser = () => {
  const location = useLocation();
  const { data } = useQuery(getUserInformation);
  const history = useHistory();

  const name = get(data, "user.name", " ");
  const email = get(data, "user.email", " ");

  const { currentLanguage, handleChangeLanguage } = useContext(
    CurrentLanguageContext
  );

  useEffect(() => {
    if (
      data?.user?.prefferedLanguage &&
      data?.user?.prefferedLanguage !== currentLanguage &&
      data?.user?.prefferedLanguage !== undefined
    ) {
      handleChangeLanguage(data?.user?.prefferedLanguage, "automatic");
    }
  });

  return (
    <div
      className="CurrentUser"
      onClick={() => {
        history.push("/");
      }}
    >
      <div className="CurrentUser__information">
        <div
          className="CurrentUser__information-name"
          style={
            location.pathname.includes("profile")
              ? { color: "#fff" }
              : { color: "#0c2c52" }
          }
        >
          {name}
        </div>
        <div
          className="CurrentUser__information-email"
          style={
            location.pathname.includes("profile")
              ? { color: "#fff" }
              : { color: "#6d7a85" }
          }
        >{`${email}`}</div>
      </div>
      <div className="CurrentUser__picture">
        <div className="CurrentUser__picture-border">
          <Icon name="iconEmployee" width={20} />
        </div>
      </div>
    </div>
  );
};

const getUserInformation = gql`
  query {
    user {
      id
      email
      name
      prefferedLanguage
    }
  }
`;
